import {
  BLOKKENDOOS_SELECTORS,
  META_TAGS,
  SIGNUP_FOR_MAPPING,
  DEFAULT_BANNER_IMAGE,
  DEFAULT_SIGNUP_FOR,
  DEFAULT_SITE_ABBR,
  DEFAULT_I18N_NS
} from './constants';

export default class Blokkendoos {
  constructor({ _document, _window } = {}) {
    this.document = _document || document;
    this.window = _window || window;
    this.jQuery = this.window.$;
  }

  triggerCandidateLoginModal() {
    this.jQuery(
      `#${BLOKKENDOOS_SELECTORS.EMAIL_NOT_UNIQUE_CONTENT}`
    ).removeClass('hidden');
    this.jQuery(BLOKKENDOOS_SELECTORS.CANDIDATE_MODAL).modal();
  }

  getBannerImage() {
    return this.getMetaContent(META_TAGS.BANNER_IMAGE) || DEFAULT_BANNER_IMAGE;
  }

  getSignupFor() {
    const signupFor = this.getMetaContent(META_TAGS.SIGNUP_FOR);
    const mappedSignupFor = SIGNUP_FOR_MAPPING[signupFor];
    return mappedSignupFor || DEFAULT_SIGNUP_FOR;
  }

  getDefaultI18nNs() {
    const signupFor = this.getMetaContent(META_TAGS.SIGNUP_FOR);
    const defaultNs = DEFAULT_I18N_NS[signupFor];
    return defaultNs || DEFAULT_SIGNUP_FOR;
  }

  getSiteAbbr() {
    const siteAbbr = this.getMetaContent(META_TAGS.SITE_ABBR);
    return siteAbbr || DEFAULT_SITE_ABBR;
  }

  getSignupEventLabel() {
    return this.getMetaContent(META_TAGS.SIGNUP_EVENT_LABEL);
  }

  getMetaContent(name) {
    return (
      this.document.querySelector(Blokkendoos.makeMetaSelector(name)) || {}
    ).content;
  }

  isMobileApp() {
    return Boolean(this.document.querySelector('.mobile-app-view'));
  }

  deleteLoader() {
    return this.jQuery('div.loader').remove();
  }

  static makeMetaSelector(name) {
    return `meta[name="${name}"]`;
  }
}
